module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn_sms-32965daca905c73365e7eba89b4abf0d.svg";